<!-- ChatWidget.vue -->
<template>
  <div class="chat-widget" @wheel.stop>
    <!-- Bouton pour ouvrir le chat -->
    <base-button
      v-if="!isOpen"
      class="chat-button btn-round btn-just-icon btn-primary"
      @click="toggleChat"
    >
      <i class="fas fa-comments icon-large"></i>
    </base-button>

    <!-- Interface du chat -->
    <div class="card card-chart" v-show="isOpen">
      <div
        class="card-header d-flex justify-content-between align-items-start bg-primary text-white p-3"
      >
        <div class="col text-left pe-2">
          <h2 class="card-title mb-0">AI Assistant</h2>
        </div>
        <!-- <base-button
                    class="btn-round btn-just-icon btn-danger close-button"
                    @click="toggleChat"
                >
                    <i class="fas fa-times"></i>
                </base-button> -->
        <base-button
          class="edit btn-link close-button"
          type="danger"
          size="sm"
          icon
          @click="toggleChat"
        >
          <i class="fas fa-times icon-large"></i>
        </base-button>
      </div>

      <div class="card-body">
        <div class="chat-messages" ref="messageContainer" v-if="isLoadingMessage">
            <div
                        v-loading="true"
                        class="h-100 d-flex justify-content-between align-items-center"
                    ></div>
        </div>
        <div class="chat-messages" ref="messageContainer" v-else>
          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="{
              'message message--user': message.isUser,
              'message message-error': message.isError
            }"
          >
            <div
              :class="
                message.isUser
                  ? 'message-content bg-info text-white'
                  : 'message-content bg-light'
              "
            >
              <!-- Message utilisateur normal -->
              <template v-if="message.isUser">
                 <div style="width: 100%; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word; overflow: hidden;"> {{ capitalizeFirstWord(message.text) }} </div>
              </template>
              <!-- Zone de réponse avec loading -->
              <template v-else>
                <template v-if="isLoading && index === messageIndex">
                  <i class="fa-solid fa-ellipsis fa-fade"></i>
                </template>
                <template v-else>
                  <b :class="message.isError ? 'text-danger' : ''">
                     <div style="width: 100%; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word; overflow: hidden;"> {{ capitalizeFirstWord(message.text) }} </div>
                  </b>

                  <base-button
                    v-if="message.isError"
                    class="edit btn-link"
                    title="Regénérer une réponse"
                    type="danger"
                    size="sm"
                    icon
                    @click="regenerateResponse(message.questionId, index)"
                  >
                    <i class="fas fa-redo"></i>
                  </base-button>
                </template>
              </template>
              <div
                class="message-time small"
                :class="message.isUser ? 'text-white-50' : 'text-muted'"
              >
                {{ formatTime(message.timestamp) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <base-alert type="warning" v-if="erreur">
                <span>
                  <template> {{ erreur }} </template>
                </span>
              </base-alert>
            </div>
          </div>
        </div>

        <div class="chat-input p-3">
          <div class="d-flex align-items-center">
            <el-input
              type="textarea"
              v-model="newMessage"
              @keyup.enter.native="newResponse()"
              placeholder="Écrivez votre message..."
              :disabled="isLoading"
              class="message-input flex-grow-1"
            />
            <base-button
              class="edit btn-link close-button"
              type="primary"
              size="sm"
              icon
              @click="newResponse()"
              :disabled="isLoading || !newMessage.trim()"
            >
              <i class="fas fa-circle-arrow-up icon-large"></i>
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseAlert } from "src/components";
export default {
  name: "ChatWidget",
  components: {
    BaseAlert
  },
  data() {
    return {
      createMessage: {
        user: (text, timestamp = new Date()) => ({
          text,
          isUser: true,
          timestamp
        }),

        assistant: (text, timestamp = new Date(), isError=false, questionId=null) => ({
          text,
          isUser: false,
          timestamp,
          isError,
          questionId
        }),

        error: (questionId = null) => ({
          text:
            "Désolé, une erreur est survenue. Veuillez réessayer plus tard.",
          isUser: false,
          timestamp: new Date(),
          isError: true,
          questionId
        }),

        loading: () => ({
          text: "",
          isUser: false,
          timestamp: new Date()
        })
      },
      regenrate: false,
      messageToUpdateIndex: null,
      question: null,
      questionId: null,
      lastQuestion: "",
      erreur: "",
      isOpen: false,
      messageIndex: null,
      messageAccueil: `Bonjour ! Je suis ravi de vous accueillir. En tant qu'assistant spécialisé en analyse LTV pour le secteur de l'assurance. Comment puis-je vous aider aujourd'hui ?
Voici un exemple de question :
"Donne moi les gains Pour l'année 2024 sur tous les produits est ton avis sur le resultat?"
Comment puis-je vous aider aujourd'hui ?`,
      messages: [],
      newMessage: "",
      isLoading: false,
      isLoadingMessage: false,
      //url_api: "http://127.0.0.1:8000/api"
      url_api: "https://api-auth-plf.wee-do-it.net/api/v1"
    };
  },
  mounted() {
    this.loadMessages();
  },

  methods: {
    capitalizeFirstWord(text) {
      // Capitalise uniquement le premier mot
      return text.replace(/^(\w)/, (match) => match.toUpperCase());
    },
    async loadMessages() {
        //return
      this.isLoadingMessage = true;
      this.axios
        //.get("http://127.0.0.1:8000/api/get_conversation_by_user", {
        .get(`${this.url_api}/get_conversation_by_user`, {
          params: {
            userId: JSON.parse(localStorage.getItem('utilisateur')).id
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_jwt")}`,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
            this.messages = [];
            if (response.data.code = 200) {
                const data = response.data.data;
                if (data.length == 0) {
                        this.messages.push( this.createMessage.assistant(this.messageAccueil, new Date()));
                }else{
                    data.forEach(entry => {
                        //Cas aucun message
                            this.messages.push( this.createMessage.user(entry.question, new Date(entry.created_at)));
                            this.messages.push( this.createMessage.assistant(
                                    entry.statut === "error" ? "Une erreur s'est produite" : entry.response,
                                    new Date(entry.created_at),
                                    entry.statut === "error",
                                    entry.id
                                )
                            );
                    });
                }

            }else{
                this.erreur = "Erreur lors du chargement des messages";
            }
        })
        .catch(error => {
            console.log("error", error);
            this.erreur = "Erreur lors du chargement des messages";
        })
        .finally(() => {
            this.isLoadingMessage = false;
            this.callScrollToBottom();
        });
    },

    callScrollToBottom(){
        this.$nextTick(() => {
                this.scrollToBottom();
            })
    },
    toggleChat() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.callScrollToBottom();
      }
    },
    sendMessageBedrock() {
        this.isLoading = true;

        this.newMessage = "";

        this.messageIndex = this.messageToUpdateIndex
            ? this.messageToUpdateIndex
            : this.messages.length - 1;

        const formData = {
            question: this.question,
            userId: JSON.parse(localStorage.getItem("utilisateur")).id,
            questionId: this.questionId
        };


        this.axios
            .post(`${this.url_api}/ask-ltv-bedrock`, formData, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${localStorage.getItem("token_jwt")}`
            }
            })
            .then(response => {
            if (response.data.code == 200) {
                const data = response.data.data;
                this.messages[this.messageIndex] = this.createMessage.assistant(
                                                        data.response,
                                                        new Date(),
                                                        data.isError || false,
                                                        data.questionId
                                                    )
            } else {
                this.messages[this.messageIndex] = this.createMessage.assistant(
                                                       "Une erreur est survenue.",
                                                        new Date(),
                                                        true,
                                                    )
            }

        })
        .catch(err => {
          console.log(err);
          this.messages[this.messageIndex] = this.createMessage.assistant(
                                                       "Uneerreur est survenue.",
                                                        new Date(),
                                                        true,
                                                    )


        })
        .finally(() => {
          if (!this.regenrate) {
            this.callScrollToBottom();
          }
          this.isLoading = false;
          this.newMessage = "";
          this.messageToUpdateIndex = null;
          this.questionId = null;
          this.question = null;
          this.regenrate = false;
        });
    },

    regenerateResponse(questionId, index) {
      this.regenrate = true;
      this.messageToUpdateIndex = index;
      this.messageIndex = index
      this.question = this.messages[this.messageIndex - 1].text
      this.questionId = questionId;
      this.messages[this.messageToUpdateIndex] = this.createMessage.assistant(
                                                        "",
                                                        new Date(),
                                                        false,
                                                        this.questionId
                                                    )
      this.sendMessageBedrock();
    },
    newResponse() {
      this.question = this.newMessage
      this.messages.push( this.createMessage.user(this.question, new Date()));
      this.messages.push( this.createMessage.assistant(
                                        "",
                                        new Date(),
                                    )
                                );
      this.messageIndex = this.messages.length - 1

      this.callScrollToBottom();
      this.sendMessageBedrock();
    },

    formatTime(date) {
      return new Date(date).toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    scrollToBottom() {
      const container = this.$refs.messageContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }
};
</script>

<style scoped>
.chat-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.chat-button {
  width: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.card-chart {
  position: absolute;
  bottom: 0px;
  right: 0;
 /* width: 600px;*/
  width: 45vw;
  height: 700px;
  margin-bottom: 0;
}

.card-header {
  padding: 15px;
  border-radius: 10px 10px 0 0;
}

.card-body {
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
  padding: 0;
}

.chat-messages {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #f8f9fa;
  overscroll-behavior: contain;
}

.message {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.message-content {
  max-width: 80%;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 5px;
}

.message--user {
  align-items: flex-end;
}

.chat-input {
  padding: 15px;
  background-color: white;
  border-top: 1px solid #dee2e6;
}

.close-button {
  padding: 0 !important;
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}

.message-input {
  height: 60px !important;
  max-height: 120px;
  overflow-y: auto;
  resize: none;
}
.message-input:focus {
  border: none !important; /* ou la couleur de votre choix */
  box-shadow: none !important;
  outline: none !important;
}

.send-button {
  height: 40px !important;
  width: 40px !important;
  padding: 0 !important;
  min-width: 40px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* Style personnalisé pour les scrollbars */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.message-error .message-content {
  background-color: #fabdc3 !important;
}

/* Pour écrans medium et large (768px à 1200px) */
/* @media (min-width: 768px) and (max-width: 1200px) {
  .card-chart {
    height: 50vh;
  }
} */
@media (min-width: 577px) and (max-width: 1024px) {
  .card-chart {
    width: 75vw;  /* 75% de la largeur de l'écran */
    height: 700px;
  }
}

@media (max-width: 576px) {
  .card-chart {
    width: calc(100vw - 40px);
    /*right: 20px;*/
  }
}
</style>
